<div class="card">
  <div class="card-body">
    <p>
      {{ card.value }}
    </p>
  </div>
  <div class="card-header">
    <span class="card-title">{{ card.label }}</span>
  </div>
</div>
